import axios from "axios";
// axios.defaults.baseURL = "http://52.221.248.43/"

export const getSignupAPI = (payload) => {
  const prodUrl = process.env.REACT_APP_BASE_URL;

  return axios
    .post(prodUrl + "user-service/api/v1/users/customer/register/", {
      full_name: payload.name,
      email_or_phone: payload.phone,
      password1: payload.password,
      password2: payload.password,
    })
    .then(function (response) {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
